module.exports = __webpack_public_path__ + "static/media/team-1@2x.db875366.jpg";